export const AGENT = 'AGENT';
export const VISITOR = 'VISITOR';
export const BOT = 'BOT';
export const SYSTEM = 'SYSTEM';
export const INTEGRATOR = 'INTEGRATOR';
export const EMAIL = 'EMAIL';